export default __webpack_public_path__ + "static/logo-f806647436fbb6f3219a588e7ba06e39.png";